import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.5 15.002a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75m0 3a.75.75 0 0 1 .75-.75H12a.75.75 0 0 1 0 1.5H8.25a.75.75 0 0 1-.75-.75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.625 1.502c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.036.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875v-9.375c0-5.384-4.365-9.75-9.75-9.75zm0 1.5a.375.375 0 0 0-.375.375v17.25c0 .207.168.375.375.375h12.75a.375.375 0 0 0 .375-.375v-9a2.625 2.625 0 0 0-2.625-2.625h-1.5a1.875 1.875 0 0 1-1.875-1.875v-1.5a2.625 2.625 0 0 0-2.625-2.625zm8.132.668c.315.583.493 1.25.493 1.957v1.5c0 .207.168.375.375.375h1.5c.708 0 1.375.179 1.957.493a8.28 8.28 0 0 0-4.325-4.325",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }